export const USER_AFFILIATION_TYPE_GLOBAL = 'GLOBAL';
export const USER_AFFILIATION_TYPE_PROVIDERGROUP = 'PROVIDERGROUP';
export const USER_AFFILIATION_TYPE_TEMPLATE = 'TEMPLATE';

export class UserAffiliation {
  userId: number;
  affiliationType: string = null;
  providerGroupIds: string[];
  sftpProviderGroupIds: string[];
  description: string;
  templateId?: string = null;
}
